import { AxiosError, AxiosResponse } from 'axios';

import { SprayEventStartDate } from 'services/sprayEvents/types';
import {
    RequestedLoadAppliedFertilizerEntitiesByDateAction,
    CanceledLoadAppliedFertilizerEntitiesByDateAction,
    SuccededLoadAppliedFertilizerEntitiesByDateAction,
    FailedLoadAppliedFertilizerEntitiesByDateAction,
    SetAppliedFertilizerEntitiesByDateAction,
    AppliedFertilizerEntitiesByDateState
} from './types';
import {
    APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_REQUESTED,
    APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_CANCELED,
    APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_SUCCEEDED,
    APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_FAILED,
    APPLIED_FERTILIZER_ENTITIES_BY_DATE_SET
} from './constants';

export function requestLoadAppliedFertilizerEntitiesByDate(
    startDate: SprayEventStartDate
): RequestedLoadAppliedFertilizerEntitiesByDateAction {
    return {
        type: APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_REQUESTED,
        payload: startDate
    };
}

export function canceledLoadAppliedFertilizerEntitiesByDate(): CanceledLoadAppliedFertilizerEntitiesByDateAction {
    return {
        type: APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_CANCELED
    };
}

export function succeededLoadAppliedFertilizerEntitiesByDate(
    response: AxiosResponse
): SuccededLoadAppliedFertilizerEntitiesByDateAction {
    return {
        type: APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadAppliedFertilizerEntitiesByDate(
    payload: AxiosError
): FailedLoadAppliedFertilizerEntitiesByDateAction {
    return {
        type: APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_FAILED,
        payload,
        error: true
    };
}

export function setAppliedFertilizerEntitiesByDate(
    entities: AppliedFertilizerEntitiesByDateState
): SetAppliedFertilizerEntitiesByDateAction {
    return {
        type: APPLIED_FERTILIZER_ENTITIES_BY_DATE_SET,
        payload: entities
    };
}
